import React from "react";
import styles from "../../static/css/pages.module.css";
import Dropdown from "../../components/form/dropdown/dropdown";
import Input from "../../components/form/input/input";
import Button from "../../components/form/button/button";
import Datepicker from "../../components/form/datepicker/datepicker";
import InputAmount from "../../components/form/input/input_amount";
import Modal from "../../components/modal/modal";
import InputMail from "../../components/form/input/input_mail";
import {connect} from "react-redux";
import {postDataAction} from "../../store/actions/postDataAction";
import * as consts from "../../store/constants/sendData";

class RegisterIncomeForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      createDate: '',
      customerInn: '',
      customerName: '',
      email: '',
      service: '',
      sum: '',
      transferDate: '',
      type: '',
      showInn: false
    };
  }

  handleDate = (value) => {
    this.setState({
      transferDate: value
    });
  }

  handleState = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({
      [name]: value,
    })
  }

  selectChange = (e) => {
    this.setState({ type: e.value });
    if (e.value === 'FROM_LEGAL_ENTITY') {
      this.setState({ showInn: true });
    }
    else {
      this.setState({ showInn: false });
    }
  };

  convert = (str) => {
    var date = new Date(str),
      mnth = ("0" + (date.getUTCMonth() + 1)).slice(-2),
      day = ("0" + date.getUTCDate()).slice(-2),
      hours = ("0" + date.getUTCHours()).slice(-2),
      minutes = ("0" + date.getUTCMinutes()).slice(-2),
      seconds = ("0" + date.getUTCSeconds()).slice(-2);
    return (date.getFullYear() + "-" + mnth + "-" + day + "T" + hours + ":" + minutes + ":" + seconds);
  }

  handleSubmit = (e) => {
    let form = e.target.closest("button");
    let formData;
    const createDate = this.convert(new Date());
    this.setState({
      createDate: createDate
    }, () => {
      formData = {
        createDate: this.state.createDate,
        email: this.state.email,
        sum: this.state.sum,
        service: this.state.service,
        transferDate: this.state.transferDate,
        type: this.state.type
      };

      if (this.state.showInn === true) {
        formData['customerInn'] = this.state.customerInn;
      }

      if (this.state.type === 'FROM_LEGAL_ENTITY' || this.state.type === 'FROM_FOREIGN_AGENCY') {
        formData['customerName'] = this.state.customerName;
      }
      this.props.fetchData(process.env.REACT_APP_GATE + "income/registration", this, consts.INCOME_REGISTRATION, formData, form);
    });
  }

  handleClose = () => {
    this.props.fetchData('', this, consts.INCOME_REGISTRATION);
    localStorage.setItem("fDataRefresh", 'true');
    document.querySelector("[data-menu='home']").click();
    // let hideButton = document.getElementById('form-hide');
    // if (hideButton) {
    //   hideButton.click()
    // }
    let reloadButton = document.getElementById('reload-income');
    if (reloadButton) {
      reloadButton.click()
    }
  }

  renderDialog(param) {
    switch (param) {
      case "ERROR":
        if(this.props.data.items.result.errorCode === 'TAXPAYER_UNBOUND' || this.props.data.items.result.errorCode === 'TAXPAYER_UNREGISTERED') {
          this.props.fetchData('', consts.INCOME_REGISTRATION, null);
          window.location=process.env.PUBLIC_URL + "/page/needRegister";
          return null;
        }
        else{
        return <Modal
          class="dialog-success l-align_center"
          modalIcon="icon_error"
          viewbox="0 0 80 80"
          handleClick={this.handleClose.bind(this)}
          title="Доход не зарегистрирован"
          body={<div className={styles.article}>
              {this.props.data.items.result.errorMessage}
              <div className={styles.article}></div>
            </div>}
          footer="l-align_right"
          link={this.handleClose.bind(this)}
          button="Закрыть"
        />;
        }
      case "TIMEOUT":
      case "SUCCESS":
        switch (this.state.type) {
          case 'FROM_LEGAL_ENTITY':
          case 'FROM_FOREIGN_AGENCY':
          case 'FROM_INDIVIDUAL':
          default:
            break;
        }
        return <Modal
              class="dialog-success l-align_center"
              modalIcon="icon_success"
              viewbox="0 0 80 80"
              handleClick={this.handleClose.bind(this)}
              title="Доход зарегистрирован"
              body={<div className={styles.article}>
                  Подробная информация в ленте <span className={styles.link} onClick={this.handleClose}>Мои доходы</span>.
                  <div className={styles.article}/>
                </div>}
              footer="l-align_right"
              link={this.handleClose.bind(this)}
              button="Закрыть"
              receiptLink={this.props.data.items.data.link}
            />;
      default:
        return null;
    }
  }

  render() {
    return (
      <div data-form>
        <div>
          <div className="l-grid">
            <div className="l-grid__item_6">
              <Dropdown label="Выберите группу" name="type" onChange={this.selectChange}
                        placeholder="" required items={[
                { value: 'FROM_INDIVIDUAL', label: 'от физического лица' },
                { value: 'FROM_LEGAL_ENTITY', label: 'от юридического лица' },
                { value: 'FROM_FOREIGN_AGENCY', label: 'от иностранной огранизации' },
              ]} />
            </div>
            <div className="l-grid__item_6">
              <Datepicker name="transferDate" label="Дата расчета" required maxDate={new Date()}
                          handleDate={this.handleDate}
              />
            </div>
          </div>
          <div className="l-grid">
            {this.state.showInn === true?
              <div className="l-grid__item_6" id="form-inn-ul">
                <Input label="ИНН заказчика" required length="10|12" maxlength="12" onChange={this.handleState}
                       value={this.state.customerInn} name="customerInn" dataNumber
                       id="form-inn" />
              </div>
              :
              null
            }
          </div>
          {
            this.state.type === 'FROM_LEGAL_ENTITY' || this.state.type === 'FROM_FOREIGN_AGENCY'?
                <Input label="Наименование организации" required onChange={this.handleState} maxlength="100"
                       value={this.state.customerName} name="customerName" />
                :
                null
          }
          <InputMail label="E-mail заказчика" name="email"
                     value={this.state.email} onChange={this.handleState}
                     maxlength="100" underinput="Чек будет отправлен на указанный e-mail"
          />
          <Input label="Услуга" maxlength="256" onChange={this.handleState} required name="service" />
          <div className="l-grid">
            <div className="l-grid__item_5">
              <InputAmount label="Сумма" name="sum" value={this.state.sum} mask={Number} onChange={this.handleState} required />
            </div>
          </div>
        </div>
        <div className="l-align_right">
          <Button title="Зарегистрировать доход" onClick={this.handleSubmit} />
        </div>
        <div>
          {this.props.data.items ?
            this.renderDialog(this.props.data.items.result.status)
            :
            null
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({data: state.incomeRegistration})

const mapDispatchToProps = dispatch => {
  return {fetchData: (url, parent, types, body, el) => dispatch(postDataAction(url, parent, types, body, el))}
}

export default connect(mapStateToProps, mapDispatchToProps)(RegisterIncomeForm);
